import "./components/consultaCep.js";
import "./components/clipboard.js";
import "./components/clipboard-pix";
import "./components/changePixText.js";
import cart from "./components/cart.js";
import "./components/changeCartUrl.js";
import "./components/checkout-multi-step";
import "./components/checkout.js";
import "./components/selected-input-radio.js";
import "./components/inputs-numeric-for-mobile.js";
import "./components/activeInputForm.js";
import "./components/adopt.js";
import "./components/checkout-enter-block.js";
import "./components/stripe-label.js";
import "./components/popup-falcon.js";

/** Single Product */
import './components/product-single.js';
import './components/swiper.js';
import './components/reorder-variation-price.js';

/** Shared components */
import "../../theme/scripts/components/naoDigitarCalendario.js";
import "../../theme/scripts/components/calendar.js";
import "../../theme/scripts/components/page-esim/index.js";
import "../../theme/scripts/components/link-whatsapp.js";
import "../../theme/scripts/components/loading-cta.js";

cart();